
/**
 * 根据list以及groupList生成一个新的list
 * @param {*} list 
 * @param {*} groupList 
 */
export const genNewList = (list, groupList) => list
	? groupList ? [].concat(list).concat(groupList) : list
	: list == false ? false : groupList

// console.log('newList:', genNewList({ fieldName: 'group', id: 2 }))
/**
 * 
 * @param {*} listArr 
 */
export const genFullList = listArr => listArr && [].concat(listArr).reduceRight((ret, list) => (
	ret.listName
		? { listName: `${ret.listName}[${ret.id}].${list.listName}`, id: list.id }
		: { ...list }
), {})

/**
 * 
 * @param {*} listArr 
 * @param {String} fieldName 
 */
export const genFullListName = (listArr, fieldName) => {
	const fullList = genFullList(listArr)
	return `${fullList ? `${fullList.listName}[${fullList.id}].` : ''}${fieldName}`
}